import { defaults, find, map, filter, contains, pluck, union, each, isArray, keys, isObject, isEmpty } from 'underscore';
import { Predicate } from './predicate';
import { PredicateUIType } from './constants';

export function extendPredicatesWithSelectorConfig(selector, predicates) {
  const selectorPredicates
    = map(selector, selectorPredicate => new Predicate(defaults(
      {
        uiType: PredicateUIType.Selector,
        removable: false,
        items: selectorPredicate.items,
        property: selectorPredicate.property,
        operator: 'in',
      },
      find(
        predicates,
        predicate => predicate.property === selectorPredicate.property
      ) || {
        value: selectorPredicate.defaultValue,
      }
    )));
  const editPredicates = filter(predicates, predicate => !contains(pluck(selector, 'property'), predicate.property));

  return union(selectorPredicates, editPredicates);
}

export function removeQueryByColumnId(query, columnId, removePopColumns = false) {
  let changed = false;

  if (!query || isEmpty(query)) {
    return changed;
  }

  const popColumnId = `PoP${columnId}`;
  const popColumnChangeId = `PoP${columnId}Change`;
  const popColumnChangePercentId = `PoP${columnId}ChangePercent`;

  let idList = [columnId];

  if (removePopColumns) {
    idList = idList.concat([popColumnId, popColumnChangeId, popColumnChangePercentId]);
  }

  each(keys(query), (key) => {
    const o = query[key];

    if (idList.indexOf(key) >= 0) {
      delete query[key]; // eslint-disable-line no-param-reassign
      changed = true;
    } else if (isArray(o)) {
      const len = o.length;
      query[key] = removePopColumns ? // eslint-disable-line no-param-reassign
        filter(o, e => !e[columnId] &&
          !e[popColumnId] &&
          !e[popColumnChangeId] &&
          !e[popColumnChangePercentId]) :
        filter(o, e => !e[columnId]);
      const newlen = query[key].length;

      if (len !== newlen) {
        changed = true;
      }

      if (newlen === 0 && changed) {
        delete query[key]; // eslint-disable-line no-param-reassign
      }
    } else if (isObject(o)) {
      each(idList, (id) => {
        if (o[id]) {
          delete o[id];
          changed = true;
        }
      });
    }
  });

  return changed;
}
